export interface TagForm {
  name: string;
  groupId: string;
  colorBg: string;
  colorText: string;
  colorDot: string;
}

export const EMPTY_TAG_FORM: TagForm = {
  name: '',
  groupId: '',
  colorBg: '',
  colorText: '',
  colorDot: '',
};

export const TAG_COLOR_PRESETS: { label: string; dot: string; values: Pick<TagForm, 'colorBg' | 'colorText' | 'colorDot'> }[] = [
  { label: 'Оранжевый',  dot: '#FF9800', values: { colorBg: '#FFF3E0', colorText: '#E65100', colorDot: '#FF9800' } },
  { label: 'Синий',      dot: '#2196F3', values: { colorBg: '#E3F2FD', colorText: '#0D47A1', colorDot: '#2196F3' } },
  { label: 'Зелёный',    dot: '#4CAF50', values: { colorBg: '#E8F5E9', colorText: '#1B5E20', colorDot: '#4CAF50' } },
  { label: 'Фиолетовый', dot: '#9C27B0', values: { colorBg: '#F3E5F5', colorText: '#6A1B9A', colorDot: '#9C27B0' } },
  { label: 'Бирюзовый',  dot: '#009688', values: { colorBg: '#E0F2F1', colorText: '#004D40', colorDot: '#009688' } },
  { label: 'Красный',    dot: '#F44336', values: { colorBg: '#FFEBEE', colorText: '#B71C1C', colorDot: '#F44336' } },
  { label: 'Жёлтый',    dot: '#FFC107', values: { colorBg: '#FFF8E1', colorText: '#F57F17', colorDot: '#FFC107' } },
  { label: 'Серый',      dot: '#9E9E9E', values: { colorBg: '#F5F5F5', colorText: '#424242', colorDot: '#9E9E9E' } },
];
